import Svg from 'components/UI/SVG'
import { ReactElement } from 'react'
import { Flex, Text } from 'theme-ui'
import CheckIcon from 'images/checkbox.svg'
import UnstyledMarkdown from 'components/UI/UnstyledMarkdown'

export default function BasePlatformFeatureList({
  featureList,
}: {
  featureList: string[]
}): ReactElement {
  return (
    <Flex sx={{ alignItems: 'flex-start', gap: '1.6rem', flexDirection: 'column' }}>
      {featureList.map(feature => (
        <Flex key={feature} sx={{ gap: '1.6rem' }}>
          <Svg svg={CheckIcon} sx={{ width: '2.4rem', height: '2.4rem' }} />
          <Text sx={{ maxWidth: ['54rem', '30.6rem', '37rem'] }}>
            <UnstyledMarkdown>{feature}</UnstyledMarkdown>
          </Text>
        </Flex>
      ))}
    </Flex>
  )
}
